export default __webpack_public_path__ + "static/media/404.ef966c06.svg";